import { api_url } from '../config'
import apiClient from './axiosInterceptor'

const getUserDetails = async () => {
  return apiClient.get(api_url + 'users/v2/profile').then(res => res)
}

const updateProfileImage = async data => {
  return apiClient.post(api_url + 'users/v2/update/profile', data).then(res => res)
}

const getUserEarnings = async () => {
  return apiClient.get(api_url + 'transactions/v2/earnings').then(res => res)
}

const getUserAffiliates = async data => {
  return apiClient.get(api_url + `affiliates/v2/joined/users`, { params: data }).then(res => res)
}

const getUserAffiliatesGraph = async data => {
  return apiClient.get(api_url + `affiliates/v2/joined/users/graph`, { params: data }).then(res => res)
}

const getTransactionGraph = async () => {
  return apiClient.get(api_url + 'transactions/v2/earnings/graph').then(res => res)
}

const getLeaderBoard = async () => {
  return apiClient.get(api_url+'users/v2/leaderboard').then(res => res)
}

const getTweetsData = async () => {
  return apiClient.get(api_url+'mediaUpdates/v2/tweets').then(res => res)
}

const setUserProfile = userDetails => {
  localStorage.setItem('userProfile', JSON.stringify(userDetails))
}

const getUserProfile = () => {
  return JSON.parse(localStorage.getItem('userProfile'))
}

const sendOptInRequest = async () => {
  return apiClient.post(api_url+'auth/v2/opt/email/updates').then(res => res)
}

const pluginInstalledStatus = () => {
  return apiClient.patch(api_url + 'users/v1/extension/installed').then(res => res)
}

const dashboardService = {
  getUserDetails,
  updateProfileImage,
  getUserEarnings,
  getUserAffiliates,
  getTransactionGraph,
  setUserProfile,
  getUserProfile,
  getUserAffiliatesGraph,
  getTweetsData,
  getLeaderBoard,
  sendOptInRequest,
  pluginInstalledStatus
}
export default dashboardService
